import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { collection, query, onSnapshot } from "firebase/firestore";

function CostumeList() {
  const [costumes, setCostumes] = useState([]);

  useEffect(() => {
    // Real-time listener for "costumes" collection
    const q = query(collection(db, "costumes"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const entries = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      // Sort if needed (e.g., by timestamp)
      entries.sort((a, b) => a.timestamp?.seconds - b.timestamp?.seconds);
      setCostumes(entries);
    });

    return () => unsubscribe(); // Clean up listener
  }, []);

  return (
    <div>
      <h2>All Submissions</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        {costumes.map((c) => (
          <div key={c.id} style={{ width: "150px", textAlign: "center" }}>
            <img
              src={c.photoURL}
              alt={c.name}
              style={{ width: "100%", borderRadius: "6px" }}
            />
            <p>{c.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CostumeList;
